function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1-linecut{fill:#fff;}.cls-2-linecut{fill:#f09d8d;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-1-linecut",
  width: 60,
  height: 60
}), React.createElement("path", {
  className: "cls-2-linecut",
  d: "M44.26,17.93H39.89L29.63,28.19l-4.08-4.08a4.72,4.72,0,1,0-3.83,2A4.84,4.84,0,0,0,24,25.47L28.54,30,24,34.55a4.61,4.61,0,0,0-2.29-.61,4.73,4.73,0,1,0,3.83,2l4.08-4.08L39.71,41.91h4.37L32.19,30ZM21.72,24a2.68,2.68,0,1,1,2.66-2.67A2.67,2.67,0,0,1,21.72,24Zm0,17.31a2.67,2.67,0,1,1,2.66-2.66A2.67,2.67,0,0,1,21.72,41.33Z"
}), React.createElement("polygon", {
  className: "cls-2-linecut",
  points: "46.76 31.05 37.26 31.05 36.16 30.02 37.15 28.99 46.76 28.99 46.76 31.05"
}), React.createElement("polygon", {
  className: "cls-2-linecut",
  points: "22.8 31.05 13.24 31.05 13.24 28.99 22.8 28.99 23.84 30.02 22.8 31.05"
})));

function SvgDisconnected(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/disconnected.b9446316.svg";
export { SvgDisconnected as ReactComponent };